import { Button } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`
export const StyledThumb = styled.img`
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
`
export const StyledHeading = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #202135;
  margin-bottom: 8px;
`
export const StyledDesc = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #3e3f58;
`
export const StyledBtn = styled(Button)`
  width: 100%;
  margin-top: 40px;
`
